/* Skilla theme interactions. Everything degrades gracefully without JS. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal on scroll */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Count-up numbers (e.g. "39g" counts 0 -> 39 and keeps the "g") */
  var counters = document.querySelectorAll('[data-count]');
  function runCount(el) {
    var txt = el.textContent.trim();
    var m = txt.match(/^(\D*)(\d+)(.*)$/);
    if (!m) return;
    var pre = m[1], target = parseInt(m[2], 10), post = m[3];
    if (reduce || target < 2) return;
    var start = null, dur = 1100;
    function tick(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + Math.round(target * eased) + post;
      if (p < 1) requestAnimationFrame(tick);
    }
    el.textContent = pre + '0' + post;
    requestAnimationFrame(tick);
  }
  if ('IntersectionObserver' in window) {
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { runCount(e.target); co.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    counters.forEach(function (el) { co.observe(el); });
  }

  /* Header shadow + sticky mobile CTA after scrolling past the hero */
  var header = document.querySelector('[data-header]');
  var cta = document.querySelector('[data-sticky-cta]');
  var hero = document.getElementById('waitlist');
  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    if (header) header.classList.toggle('is-scrolled', y > 10);
    if (cta && hero) {
      var past = hero.getBoundingClientRect().bottom < 0;
      cta.classList.toggle('is-visible', past);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- 3D box: drag to spin any direction, tap to open ---------- */
  document.querySelectorAll('[data-box3d]').forEach(function (box) {
    var stage = box.querySelector('[data-box3d-stage]');
    var inner = box.querySelector('[data-box3d-inner]');
    if (!stage || !inner) return;
    var rx = -10, ry = -24, vx = 0, vy = 0;
    var dragging = false, moved = 0, lx = 0, ly = 0, lastMove = 0, idleSince = 0;
    var open = false, inView = true, easeTimer = null;
    function apply() { inner.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)'; }
    function nearest(cur, target) { return cur + ((((target - cur) % 360) + 540) % 360 - 180); }
    function easeTo(x, y) {
      rx = nearest(rx, x); ry = nearest(ry, y); vx = vy = 0;
      inner.classList.add('is-easing'); apply();
      clearTimeout(easeTimer); easeTimer = setTimeout(function () { inner.classList.remove('is-easing'); }, 780);
    }
    function setOpen(v) {
      open = v;
      box.classList.toggle('is-open', open);
      stage.setAttribute('aria-pressed', open ? 'true' : 'false');
      if (open) easeTo(-16, -14);
      idleSince = performance.now();
    }
    apply();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { inView = en[0].isIntersecting; }).observe(box);
    }
    function loop(t) {
      if (!dragging && inView && !inner.classList.contains('is-easing')) {
        if (Math.abs(vx) > 0.02 || Math.abs(vy) > 0.02) {
          ry += vx; rx += vy; vx *= 0.94; vy *= 0.94; apply(); idleSince = t;
        } else if (!reduce && !open && t - idleSince > 2600) {
          ry += 0.22; rx += (-10 - rx) * 0.01; apply();
        }
      }
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
    stage.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true; moved = 0; lx = e.clientX; ly = e.clientY; vx = vy = 0;
      inner.classList.remove('is-easing');
      box.classList.add('is-dragging', 'is-touched');
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - lx, dy = e.clientY - ly;
      lx = e.clientX; ly = e.clientY; moved += Math.abs(dx) + Math.abs(dy);
      ry += dx * 0.55; rx -= dy * 0.55; vx = dx * 0.55; vy = -dy * 0.55; lastMove = performance.now();
      apply();
    });
    function end() {
      if (!dragging) return;
      dragging = false; box.classList.remove('is-dragging');
      if (performance.now() - lastMove > 80) { vx = vy = 0; }
      idleSince = performance.now();
      if (moved < 7) setOpen(!open);
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', function () { dragging = false; box.classList.remove('is-dragging'); });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(!open); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); easeTo(rx, ry - 45); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); easeTo(rx, ry + 45); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); easeTo(rx + 45, ry); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); easeTo(rx - 45, ry); }
    });
  });

  /* ---------- Skilla Club membership + members-only flavor vote ----------
     A visitor counts as a member once they join with any email form on the site
     (hero waitlist, Skilla Club, or the vote's unlock form), when they are logged in,
     or when they arrive from a Club email link ending in ?club=1 (unlocks on a new device).
     Shopify reloads the page with ?customer_posted=true after a successful signup. */
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  var qs = window.location.search || '';
  var justPosted = /[?&]customer_posted=true/.test(qs);
  var joinPending = lsGet('skilla_join_pending');
  var votePending = lsGet('skilla_vote_pending');
  lsDel('skilla_join_pending'); lsDel('skilla_vote_pending');
  var justJoined = justPosted && !!joinPending;
  var justVoted = justPosted && !!votePending;
  if (justJoined || justVoted || /[?&]club=1/.test(qs)) lsSet('skilla_club', '1');
  if (justVoted) lsSet('skilla_voted', '1');

  document.querySelectorAll('.js-signup, .js-unlock').forEach(function (form) {
    form.addEventListener('submit', function () {
      var em = form.querySelector('input[type="email"]');
      lsSet('skilla_join_pending', form.classList.contains('js-unlock') ? 'unlock' : '1');
      if (em && em.value) lsSet('skilla_email', em.value.trim());
    });
  });

  document.querySelectorAll('[data-vote]').forEach(function (card) {
    var member = card.hasAttribute('data-member') || lsGet('skilla_club') === '1';
    if (!member) return;
    card.classList.remove('is-locked');
    var email = card.querySelector('.js-vote input[type="email"]');
    var saved = lsGet('skilla_email');
    if (email && !email.value && saved) email.value = saved;
    if (lsGet('skilla_voted') === '1') {
      card.classList.add('is-voted');
      var ok = card.querySelector('.js-vote-success');
      if (ok) ok.hidden = false;
    } else if (justJoined && joinPending === 'unlock') {
      var hi = card.querySelector('.js-vote-welcome');
      if (hi) hi.hidden = false;
    }
    if ((justJoined && joinPending === 'unlock') || justVoted) {
      setTimeout(function () { card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }, 150);
    }
  });

  /* Flavor vote: show write-in box and turn the choice into customer tags */
  document.querySelectorAll('.js-vote').forEach(function (form) {
    var tags = form.querySelector('.js-vote-tags');
    var writein = form.querySelector('.js-writein');
    var idea = form.querySelector('.js-idea');
    if (!tags) return;
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'vote_choice') return;
      var isWrite = e.target.hasAttribute('data-writein');
      if (writein) writein.hidden = !isWrite;
      if (idea) idea.required = isWrite;
      if (isWrite && idea) idea.focus();
    });
    form.addEventListener('submit', function (e) {
      var choice = form.querySelector('input[name="vote_choice"]:checked');
      if (!choice) { e.preventDefault(); return; }
      var value = 'newsletter, skilla-club, flavor-vote';
      if (choice.hasAttribute('data-writein')) {
        var text = (idea && idea.value ? idea.value : '').replace(/,/g, ' ').trim().slice(0, 40);
        value += ', vote-write-in' + (text ? ', idea: ' + text : '');
      } else {
        value += ', vote-' + choice.value;
      }
      tags.value = value;
      lsSet('skilla_vote_pending', '1');
      var em = form.querySelector('input[type="email"]');
      if (em && em.value) lsSet('skilla_email', em.value.trim());
    });
  });


  /* ---------- Modals and drawer (account panel, mobile menu) ---------- */
  var lastFocus = null;
  function openLayer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    document.querySelectorAll('[data-modal]:not([hidden]),[data-drawer]:not([hidden])').forEach(closeLayer);
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    document.body.classList.add('no-scroll');
    document.querySelectorAll('[data-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusable = el.querySelector('a, button, input');
    if (focusable) focusable.focus();
  }
  function closeLayer(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    document.querySelectorAll('[data-open="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { el.hidden = true; }, reduce ? 0 : 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openLayer(opener.getAttribute('data-open')); return; }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      var layer = closer.closest('[data-modal],[data-drawer]');
      if (layer) closeLayer(layer);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-modal]:not([hidden]),[data-drawer]:not([hidden])').forEach(closeLayer);
    var chatPanel = document.querySelector('[data-chat-panel]:not([hidden])');
    if (chatPanel) toggleChat(false);
  });

  /* ---------- Signup forms: optional ZIP saved as a tag ---------- */
  document.querySelectorAll('.js-signup').forEach(function (form) {
    form.addEventListener('submit', function () {
      var tags = form.querySelector('.js-signup-tags');
      var zip = form.querySelector('.js-zip');
      if (!tags) return;
      var value = tags.getAttribute('data-base') || tags.value;
      var z = zip ? zip.value.replace(/\D/g, '').slice(0, 5) : '';
      if (z.length === 5) value += ', zip-' + z;
      tags.value = value;
      lsSet('skilla_vote_pending', '1');
      var em = form.querySelector('input[type="email"]');
      if (em && em.value) lsSet('skilla_email', em.value.trim());
    });
  });

  /* ---------- Review tabs ---------- */
  document.querySelectorAll('[data-reviews]').forEach(function (wrap) {
    var chips = wrap.querySelectorAll('[data-filter]');
    var cards = wrap.querySelectorAll('.review');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-filter');
        chips.forEach(function (c) { var on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-selected', on ? 'true' : 'false'); });
        cards.forEach(function (card, i) {
          var show = f === 'all' || card.getAttribute('data-cat') === f;
          card.hidden = !show;
          if (show) { card.classList.remove('pop-in'); void card.offsetWidth; card.style.setProperty('--d', (i % 3) * 70 + 'ms'); card.classList.add('pop-in'); }
        });
      });
    });
  });

  /* ---------- Skilla Club: inbox preview + Drop 1 countdown ---------- */
  document.querySelectorAll('[data-club-inbox]').forEach(function (inbox) {
    var items = [].slice.call(inbox.querySelectorAll('[data-mail]'));
    var i = 0;
    function show(n) {
      items.forEach(function (m, k) { m.classList.toggle('is-active', k === n); });
    }
    items.forEach(function (m, k) {
      m.addEventListener('click', function () { i = k; show(i); });
    });
    if (items.length) {
      show(0);
      if (!reduce) setInterval(function () { if (!document.hidden) { i = (i + 1) % items.length; show(i); } }, 3200);
    }
  });
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown') + 'T09:00:00');
    if (isNaN(target)) return;
    var d = el.querySelector('[data-cd-days]'), h = el.querySelector('[data-cd-hours]'), m = el.querySelector('[data-cd-mins]');
    var live = el.querySelector('[data-cd-live]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var ms = target - new Date();
      if (ms <= 0) { el.classList.add('is-live'); if (live) live.hidden = false; return; }
      var mins = Math.floor(ms / 60000);
      if (d) d.textContent = Math.floor(mins / 1440);
      if (h) h.textContent = pad(Math.floor(mins / 60) % 24);
      if (m) m.textContent = pad(mins % 60);
    }
    tick(); setInterval(tick, 30000);
  });

  /* ---------- Help chat ---------- */
  var chat = document.querySelector('[data-chat]');
  function toggleChat(force) {
    if (!chat) return;
    var panel = chat.querySelector('[data-chat-panel]');
    var bubble = chat.querySelector('.chat__bubble');
    var open = typeof force === 'boolean' ? force : panel.hidden;
    if (open) { panel.hidden = false; requestAnimationFrame(function () { panel.classList.add('is-open'); }); chat.classList.add('is-open'); var inp = chat.querySelector('[data-chat-input]'); if (inp && window.innerWidth > 749) inp.focus(); }
    else { panel.classList.remove('is-open'); chat.classList.remove('is-open'); setTimeout(function () { panel.hidden = true; }, reduce ? 0 : 250); }
    bubble.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (chat) {
    var log = chat.querySelector('[data-chat-log]');
    var cfgEl = chat.querySelector('[data-chat-config]');
    var cfg = {}; try { cfg = JSON.parse(cfgEl.textContent); } catch (err) {}
    var qas = Array.prototype.map.call(chat.querySelectorAll('[data-q]'), function (b) { return { q: b.getAttribute('data-q'), a: b.getAttribute('data-a') }; });
    function addMsg(text, who) {
      var m = document.createElement('div');
      m.className = 'msg msg--' + who;
      m.textContent = text;
      log.appendChild(m);
      log.scrollTop = log.scrollHeight;
      return m;
    }
    function botReply(text) {
      var t = addMsg('', 'bot');
      t.classList.add('msg--typing');
      t.innerHTML = '<span></span><span></span><span></span>';
      setTimeout(function () { t.classList.remove('msg--typing'); t.textContent = text; log.scrollTop = log.scrollHeight; }, reduce ? 0 : 700);
    }
    var stop = ['the','a','an','is','it','do','i','you','how','what','when','can','of','to','my','in','for','does','are','much','where','and','your'];
    function words(s) { return s.toLowerCase().replace(/[^a-z0-9 ]/g, ' ').split(/\s+/).filter(function (w) { return w.length > 2 && stop.indexOf(w) === -1; }); }
    function answer(q) {
      var qw = words(q), best = null, score = 0;
      qas.forEach(function (item) {
        var hay = words(item.q + ' ' + item.a), s = 0;
        qw.forEach(function (w) { hay.forEach(function (h) { if (h.indexOf(w) === 0 || w.indexOf(h) === 0) s++; }); });
        if (s > score) { score = s; best = item; }
      });
      return score > 0 ? best.a : (cfg.fallback || 'Tap Talk to a human and we will email you back.');
    }
    chat.querySelectorAll('[data-chat-toggle]').forEach(function (b) { b.addEventListener('click', function () { toggleChat(); }); });
    chat.querySelectorAll('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () { addMsg(b.getAttribute('data-q'), 'user'); botReply(b.getAttribute('data-a')); });
    });
    var form = chat.querySelector('[data-chat-form]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = form.querySelector('[data-chat-input]');
      var q = inp.value.trim();
      if (!q) return;
      addMsg(q, 'user'); inp.value = '';
      botReply(answer(q));
    });
    document.querySelectorAll('[data-open-chat]').forEach(function (b) { b.addEventListener('click', function () { toggleChat(true); }); });
  }

  /* ---------- Review read-more + mobile carousel dots ---------- */
  document.querySelectorAll('.review').forEach(function (card) {
    var text = card.querySelector('[data-clamp]');
    var btn = card.querySelector('[data-more]');
    if (!text || !btn) return;
    requestAnimationFrame(function () {
      if (text.scrollHeight > text.clientHeight + 4) btn.hidden = false;
    });
    btn.addEventListener('click', function () {
      var open = card.classList.toggle('is-open');
      btn.textContent = open ? 'Show less' : 'Read more';
    });
  });
  document.querySelectorAll('[data-reviews-track]').forEach(function (track) {
    var dotsWrap = track.parentNode.querySelector('[data-dots]');
    if (!dotsWrap) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.review'));
    cards.forEach(function (c, i) {
      var d = document.createElement('button');
      d.type = 'button'; d.tabIndex = -1;
      d.addEventListener('click', function () { c.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'center', block: 'nearest' }); });
      dotsWrap.appendChild(d);
    });
    function sync() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
      cards.forEach(function (c, i) { if (c.hidden) return; var cm = c.offsetLeft + c.offsetWidth / 2; var dd = Math.abs(cm - mid); if (dd < bd) { bd = dd; best = i; } });
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) { d.classList.toggle('is-active', i === best); d.hidden = cards[i].hidden; });
    }
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  });

  root.classList.add('js-ready');
})();
